// extracted by mini-css-extract-plugin
module.exports = {"itemWrapper":"PurchasedItem_itemWrapper__2AXZC","itemImage":"PurchasedItem_itemImage__j_2vB"};